<template>
  <el-menu class="navbar">
    <hamburger
      class="hamburger-container"
      :toggleClick="toggleSideBar"
      :isActive="sidebar.opened"
    ></hamburger>
    <levelbar></levelbar>
    <!-- <tabs-view></tabs-view> -->
    <a class="doc" :href="tzUrl" download></a>
    <a class="downLink" :href="downloadUrl" download>操作手册</a>
    <!-- <span v-if=" userInfo.userTp != 'empty'" style="margin-right:9px;" class="userName" :title="userInfo.userName">{{userInfo.userName}}</span> -->
    <span
      style="margin-right: 32px"
      :title="userInfo.userName"
      class="userName"
      >{{ userInfo.userName }}</span
    >
    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <!-- <img class="user-avatar" :src="avatar"> -->
        <!-- 登出 -->

        <img class="userHome" :src="img_main" alt="" />

        <!-- <i class="el-icon-caret-bottom"></i> -->
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <router-link class="inlineBlock" to="/">
          <el-dropdown-item> 首页 </el-dropdown-item>
        </router-link>
        <span @click="logout" style="display: block"
          ><el-dropdown-item divided>注销</el-dropdown-item></span
        >
      </el-dropdown-menu>
    </el-dropdown>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex';
import Levelbar from './Levelbar';
import TabsView from './TabsView';
import img_main from '@/assets/images/main.png'
import Hamburger from '@/components/Hamburger';

export default {
  components: {
    Levelbar,
    Hamburger,
    TabsView
  },
  data() {
    return {
      img_main,
      downloadUrl: '',
      tzUrl: ''
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'userInfo'
    ])
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload();  // 为了重新实例化vue-router对象 避免bug
      });
    }
  },
  created: function () {
    var downLinks = ['/static/data/用户操作手册210813.pdf'];
    this.downloadUrl = process.env.BASE_API + downLinks[0];
    this.tzUrl = process.env.BASE_API + '/Uploads/tz/tz.pdf';
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  // line-height: 50px;

  border-radius: 0px !important;
  border-bottom: solid 1px #e6e6e6;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .errLog-container {
    display: inline-block;
    position: absolute;
    right: 150px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .userName {
    float: right;
    width: 360px;
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    margin-top: 15px;
    font-size: 14px;
  }
  .userHome {
    height: 30px;
    margin-top: 10px;
  }
  .doc {
    float: right;
    margin-top: 15px;
    margin-right: 72px;
    font-size: 14px;
    color: #409eff;
  }
  .downLink {
    float: right;
    margin-top: 15px;
    margin-right: 72px;
    font-size: 14px;
    color: #409eff;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      position: relative;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Navbar.vue?a8028544